import R from 'ramda';

const getCurrentStep = R.pathOr(0, ['activationModal', 'currentStep']);

export default getCurrentStep;
